import React from "react";
import LinkButton from "../components/BaseButton/LinkButton";
import "../index.css";


function PaymentSuccess() {

    return (
        <>
            <div className="flex-col flex-center gap1" style={{ marginTop: "30%" }}>
                <div className="payment-result-icon payment-result-icon-success">
                    <svg>
                        <use xlinkHref="#icon-check"></use>
                    </svg>
                </div>
                <h2>Платеж обработан</h2>

                <span className="grey" style={{ textAlign: "center" }}>
                    Инструкцию по подключению вы найдете в главном меню в разделе "Установка и настройка"
                </span>

                <LinkButton
                    to="/menu"
                >
                    <span>Вернуться в главное меню</span>
                </LinkButton>
            </div>
        </>
    );
}

export default PaymentSuccess;
